<div class="app-root" [class.drtv]="drtv">
  <div id="splash-page" [hidden]="!showSplash" class="dissolve-animation">
    <div class="page-splash">
      <div class="page-splash-message">My Gift for Kids</div>
      <div class="splash-progress">
        <div class="splash-progress__bar"></div>
      </div>
    </div>
  </div>

  <app-header-bar
    [isHidden]="hideHeader"
    [hideCMNBranding]="hideCmnBranding"
    [hideAbout]="hideAboutNav"
  ></app-header-bar>

  <div [ngClass]="{'app-shell': !drtv}">
    <!-- <div ng-view="" class="shuffle-animation"></div> -->
    <!-- leaving comment here until we implement the shuffle animation -->
    <router-outlet></router-outlet>
  </div>

  @if (!drtv) {
    <footer class="footer app-footer" appMobileFooter>
      <app-footer-bar [hideBrandingText]="hideFooterBrandingText"></app-footer-bar>
    </footer>
  }

  <app-spinner></app-spinner>
  @if (showUnderConstruction) {
    <app-under-construction
      (closed)="closeUnderConstruction()"
    ></app-under-construction>
  }
</div>
